import { NbMenuItem } from '@nebular/theme';

export const TEACHER_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    link: '/test-quizzes/classroom-details/teacher-classroom/true',
    pathMatch: 'full',
    home: true,
  },
  {
    title: 'Classrooms',
    icon: 'layout-outline',
    expanded: false,
    link: '/test-quizzes',
    pathMatch: 'full',
  },
  {
    title: 'School',
    icon: 'book-open-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'Calendar',
        icon: 'calendar-outline',
        link: '/calendar',
        pathMatch: 'full',
      },
      {
        title: 'Documents',
        icon: 'file-text-outline',
        link: '/documents',
        pathMatch: 'full',
      },
      {
        title: 'Events',
        icon: 'speaker-outline',
        link: '/calendar/upcoming-events',
        pathMatch: 'full',
      },
      // {
      //   title: 'Assessment',
      //   icon: 'clipboard-outline',
      //   expanded: false,
      //   link: '/test-quizzes/assessment',
      // },
    ],
  },
  {
    title: 'Communication',
    icon: 'message-circle-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'Contact/Messaging',
        icon: 'email-outline',
        expanded: false,
        link: '/messaging',
        pathMatch: 'full',
      },
      {
        title: 'Help Requests',
        icon: 'paper-plane-outline',
        expanded: false,
        link: '/request-help',
      },
      {
        title: 'Climate Survey',
        icon: 'file-outline',
        expanded: false,
        pathMatch: 'full',
        link: '/take-climate-survey',
      },
      // {
      //   title: 'Assessment',
      //   icon: 'clipboard-outline',
      //   expanded: false,
      //   link: '/test-quizzes/assessment',
      // },
    ],
  },
  // {
  //   title: 'Contact/Messaging',
  //   icon: 'email-outline',
  //   expanded: false,
  //   link: '/messaging',
  //   pathMatch: 'full',
  // },
  {
    title: 'Notifications/Alerts',
    icon: 'bell-outline',
    expanded: false,
    link: '/notifications',
    pathMatch: 'full',
  },
  {
    title: 'Requests',
    icon: 'repeat-outline',
    expanded: false,
    link: '/requests',
    pathMatch: 'full',
  },
  // {
  //   title: 'Help Requests',
  //   icon: 'paper-plane-outline',
  //   expanded: false,
  //   link: '/request-help',
  // },
  // {
  //   title: 'Climate Survey',
  //   icon: 'file-outline',
  //   expanded: false,
  //   pathMatch: 'full',
  //   link: '/take-climate-survey',
  // },
  // {
  //   title: 'MindSpace',
  //   icon: 'smiling-face-outline',
  //   link: '/mind-space',
  // },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const STUDENT_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    link: '/dashboard/student-dashboard',
    pathMatch: 'full',
    home: true,
  },
  {
    title: 'Classrooms',
    icon: 'book-outline',
    expanded: false,
    link: '/test-quizzes',
    pathMatch: 'full',
  },

  {
    title: 'School Calendar',
    icon: 'calendar-outline',
    expanded: false,
    link: '/calendar',
  },
  {
    title: 'Contact/Messaging',
    icon: 'email-outline',
    expanded: false,
    link: '/messaging',
    pathMatch: 'full',
  },

  {
    title: 'Help Requests',
    icon: 'paper-plane-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'Incoming Requests',
        icon: 'swap-outline',
        link: '/request-help',
        pathMatch: 'full',
      },
      {
        title: 'Outgoing Requests',
        icon: 'sync-outline',
        link: '/request-help/my-requests',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Notifications/Alerts',
    icon: 'bell-outline',
    expanded: false,
    link: '/notifications',
    pathMatch: 'full',
  },
  {
    title: 'Climate Survey',
    icon: 'file-outline',
    expanded: false,
    pathMatch: 'full',
    link: '/take-climate-survey',
  },
  // {
  //   title: 'MindSpace',
  //   icon: 'smiling-face-outline',
  //   link: '/mind-space',
  // },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const ADMIN_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    link: '/dashboard/admin-dashboard',
    pathMatch: 'full',
    home: true,
  },

  {
    title: 'School',
    icon: 'calendar-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'Calendar',
        link: '/calendar',
        pathMatch: 'full',
      },
      {
        title: 'Instructional Periods',
        link: '/instructional-periods',
        pathMatch: 'full',
      },
      {
        title: 'Manage School Years',
        link: '/manage-school-years/list-view',
        pathMatch: 'full',
      },
      // {
      //   title: 'Manage School Years',
      //   link: '/manage_school_years',
      //   pathMatch: 'full',
      // },
      // {
      //   title: 'Power Up Points',
      //   icon: 'pantone-outline',
      //   link: 'power-up-points',
      //   pathMatch: 'full',
      // },
    ],
  },

  {
    title: 'Contact/Messaging',
    icon: 'email-outline',
    link: '/messaging',
    expanded: false,
    pathMatch: 'full',
  },
  {
    title: 'Notifications/Alerts',
    icon: 'bell-outline',
    expanded: false,
    link: '/notifications',
    pathMatch: 'full',
  },

  {
    title: 'Requests',
    icon: 'repeat-outline',
    expanded: false,
    link: '/requests',
    pathMatch: 'full',
  },
  {
    title: 'Documents',
    icon: 'file-text-outline',
    link: '/documents',
    pathMatch: 'full',
  },
  // {
  //   title: 'Parent Student Management',
  //   icon: 'book-open-outline',
  //   link: '/manage-users/parent-user-management',
  //   pathMatch: 'full',
  // },
  // {
  //   title: 'Student Transfer Management',
  //   icon: 'book-open-outline',
  //   link: '/manage-users/student-transfer-management',
  //   pathMatch: 'full',
  // },
  // {
  //   title: 'MindSpace',
  //   icon: 'smiling-face-outline',
  //   link: '/mind-space',
  // },
  {
    title: 'LCAP Wizard',
    icon: 'file-text-outline',
    expanded: false,
    pathMatch: 'full',
    children: [
      {
        title: 'LCAP Generator',
        link: '/admin-lcap-reports',
        pathMatch: 'full',
      },
      {
        title: 'Climate Survey',
        link: '/climate-survey',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const SUPER_ADMIN_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    pathMatch: 'prefix',
    home: true,
    children: [
      // {
      //   title: 'My Dashboard',
      //   // link: '/dashboard',
      // },
      {
        title: 'Admin Dashboard',
        link: '/dashboard/admin-list',
        pathMatch: 'full',
      },
      {
        title: 'Teacher Dashboard',
        link: '/dashboard/teacher-dashboard',
        pathMatch: 'full',
      },
      {
        title: 'Signup Activity',
        link: '/dashboard/signup-activity',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Calendar',
    icon: 'calendar-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'School Calendar',
        link: '/calendar',
        pathMatch: 'full',
      },
      // {
      //   title: 'Teacher Calendar',
      //   link: '/calendar/teacher-calender-view',
      // },
      {
        title: 'Pacing Plan',
        link: '/pacing-lesson-plan',
        pathMatch: 'full',
      },
      {
        title: 'Lesson Plan',
        link: '/pacing-lesson-plan/admin-lesson-plan',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Contact/Messaging',
    icon: 'email-outline',
    link: '/messaging',
    expanded: false,
    pathMatch: 'full',
  },

  {
    title: 'Documents',
    icon: 'file-text-outline',
    link: '/documents',
    pathMatch: 'full',
  },

  {
    title: 'User Management',
    icon: 'people-outline',
    pathMatch: 'prefix',
    children: [
      {
        title: 'Manage Users',
        link: '/manage-users',
        pathMatch: 'full',
      },
      {
        title: 'Schools',
        link: '/manage-users/school',
        pathMatch: 'full',
      },
      {
        title: 'Analytics',
        link: '/manage-users/time-management',
        pathMatch: 'full',
      },

      // {
      //   title: 'Feedback',
      //   link: '/feedback',
      //   pathMatch: 'full',
      // },
      {
        title: 'Parent Student Management',
        link: '/manage-users/parent-user-management',
        pathMatch: 'full',
      },
      // {
      //   title: 'Subscription Details',
      //   link: '/subscription-details',
      //   pathMatch: 'full',
      // },
    ],
  },

  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const PARENT_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    link: '/dashboard/parent-dashboard',
    home: true,
  },
  {
    title: 'School',
    icon: 'book-open-outline',
    expanded: false,
    pathMatch: 'prefix',
    children: [
      {
        title: 'Calendar',
        icon: 'calendar-outline',
        link: '/calendar',
        pathMatch: 'full',
      },
      {
        title: 'Documents',
        icon: 'file-text-outline',
        link: '/documents',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Contact/Messaging',
    icon: 'email-outline',
    link: '/messaging',
    expanded: false,
    pathMatch: 'full',
  },
  {
    title: 'Notifications/Alerts',
    icon: 'bell-outline',
    expanded: false,
    link: '/notifications',
    pathMatch: 'full',
  },
  // {
  //   title: 'MindSpace',
  //   icon: 'smiling-face-outline',
  //   link: '/mind-space',
  // },
  {
    title: 'Climate Survey',
    icon: 'file-outline',
    expanded: false,
    pathMatch: 'full',
    link: '/take-climate-survey',
  },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const OTHER_STAFF_MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'Calendar',
    icon: 'calendar-outline',
    expanded: false,
    pathMatch: 'prefix',
    home: true,
    children: [
      {
        title: 'School Calendar',
        link: '/calendar',
        pathMatch: 'full',
      },
      {
        title: 'Instructional Periods',
        link: '/instructional-periods',
        pathMatch: 'full',
      },
      {
        title: 'Events',
        link: '/calendar/upcoming-events',
        pathMatch: 'full',
      },
    ],
  },
  {
    title: 'Contact/Messaging',
    icon: 'email-outline',
    link: '/messaging',
    expanded: false,
    pathMatch: 'full',
  },
  {
    title: 'Notifications/Alerts',
    icon: 'bell-outline',
    expanded: false,
    link: '/notifications',
    pathMatch: 'full',
  },
  {
    title: 'Requests',
    icon: 'repeat-outline',
    expanded: false,
    link: '/requests',
  },
  {
    title: 'Documents',
    icon: 'book-open-outline',
    link: '/documents',
    pathMatch: 'full',
  },
  {
    title: 'Climate Survey',
    icon: 'file-outline',
    expanded: false,
    pathMatch: 'full',
    link: '/take-climate-survey',
  },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];

export const TEACHER_ONLY: NbMenuItem[] = [
  {
    title: 'Dashboard',
    icon: 'cube-outline',
    expanded: false,
    link: '/test-quizzes/classroom-details/teacher-classroom/true',
    pathMatch: 'full',
    home: true,
  },
  {
    title: 'Classrooms',
    icon: 'layout-outline',
    expanded: false,
    link: '/test-quizzes',
    pathMatch: 'full',
  },
  {
    title: 'Assistant',
    icon: 'headphones-outline',
    expanded: false,
    link: '/teacher-only-assistant',
    pathMatch: 'full',
  },
  {
    title: 'Profile',
    icon: 'person-outline',
    expanded: false,
    link: '/profile',
    pathMatch: 'full',
  },
];
